<template>
  <div class="my-pic">
    <div class="pic-title">
      <el-upload
        class="upload-demo"
        action="api/upload.php"
        :before-upload="beforeAvatarUpload"
        :on-success="handleSuccess"
        :on-error="handleError"
        :file-list="fileList"
        :limit="1">
        <el-button  type="success">点击上传</el-button>
      </el-upload>
      <el-button @click="moreDelete" type="success">删除图片</el-button>
      <div class="icon-warn">
        <span class="gray-btn" v-if="picList">容量：{{picList.length || 1}}/50</span>
        <el-popover
          placement="bottom"
          width="200"
          trigger="hover"
          content="每个用户可享有50张图片容量，图片支持jpg/jpeg/png/gif格式，需小于2M">
          <el-button slot="reference" type="text" class="el-icon-question help-icon"></el-button>
        </el-popover>
      </div>
    </div>
    <div class="pic-list" id="pic-list" >
      <ul v-if="picList && picList.length > 0">
        <li v-for="item in picList" :key="item.id">
          <div class="opreate-btn">
            <el-popover
              popper-class="opreate-popover"
              placement="top-start"
              trigger="hover"
              content="删除">
              <el-button @click.stop="singleDelete(item.id)" slot="reference" type="text" class="el-icon-delete btn-txt delete-btn"></el-button>
            </el-popover>
            <el-checkbox v-model="item.checked"></el-checkbox>
          </div>
          <img  @click.stop="imgClick(item)" :src="item.src" />
        </li>
      </ul>
      <div class="no-pic" v-else>
        <img src="../../assets/images/no-data.png" />
        <p>你只有<span class="orange">登录</span>或<span class="orange">注册</span>后才能上传自己的图片</p>
      </div>
      <div v-infinite-scroll="hideScroll" :infinite-scroll-disabled="busy" :infinite-scroll-distance="10"></div>
    </div>
  </div>
</template>

<script>
import MaterialService from '@/service/api/materialService'
import _ from 'lodash'

export default {
  data() {
    return {
      fileList: [],
      selectVal: {
        m: null,
        page: 1,
        tag: null
      },
      busy: false,
      scroll: true,
      total: null,
      checked: true,
      picList: []
    }
  },
  props: ['activeMenu'],
  created () {
    this.selectVal.m = this.activeMenu
    this.getPicList()
  },
  methods: {
    getPicList (flag) {
      const materialSystem = new MaterialService()
      materialSystem.materialList(this.selectVal)
        .then(({ data }) => {
          if (data.data) {
            _.each(data.data, (val) => {
              val.checked = false
            })
          }
          if(flag){
            // 多次加载数据
            this.picList = [
              ...this.picList,
              ...data.data
            ]
            if(data.data.length === 0){
              this.busy = true;
            }else{
              this.busy = false;
            }
          }else{
            // 第一次加载数据
            this.picList = data.data;
            // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
            this.busy = false;
          }
        }, (error) => {
          this.$notify.error(error.message)
      })
    },
    hideScroll () {
      this.busy = true;
      // 多次加载数据
      setTimeout(() => {
        this.selectVal.page ++;
        if (this.selectVal.page > this.total) {
          return
        } else {
          this.getPicList(true);
        }
      }, 1000);
    },
    imgClick (obj) {
      this.$emit("add_ueditor_value", obj);
    },
    handleChange () {
      console.log(333)
    },
    handleSuccess (file, data) {
      console.log(data)
    },
    handleError (error,file) {
      console.log(error)
    },
    beforeAvatarUpload(file) {
      const isJPG = (file.type.indexOf('image') === 0) && (/\.(?:jpg|png|jpeg|gif)$/.test(file.name));
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpeg/JPG/PNG格式!');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB');
      }
      return isJPG && isLt2M;
    },
    singleDelete (id) {
      const arr = []
      arr.push(id)
      this.deleteFunc(arr)
    },
    moreDelete () {
      const arr =[]
      _.each(this.picList, (val) => {
        if(val.checked) {
          arr.push(val.id)
        }
      })
      this.deleteFunc(arr)
    },
    deleteFunc (ids) {
      const str = '确定要删除选中的图片吗？若文章或外网引用了此图片，那么在外网或文章中该图片将无法显示;如已同步到微信公众号的文章不受影响'
      this.$confirm(`${str}`, '删除图片')
      .then(() => {
        const materialSystem = new MaterialService()
        materialSystem.deletePic({id: ids})
          .then(() => {
            this.getPicList()
          }, (error) => {
           this.$notify.error(error.message)
          })
      })
    }
  },
  computed: {
    htmlHeight () {
      return $("#pic-list ul").height()
    }
  }
}
</script>

<style lang="scss" scoped>
.my-pic{
  .pic-title{
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    padding-bottom: 15px;
    border-bottom: solid 1px #ccc;
    .icon-warn{
      display: flex;
      align-items: center;
      justify-content: space-around;
      font-size: 12px;
      margin-top: -3px;
      .help-icon{
        color: #d6d6d6;
        font-size: 18px;
        &:hover{
          color: #67c23a
        }
      }
      .gray-btn{
        color: #878787;
        margin-right: 5px;
      }
    }
  }
  .pic-list{
    margin: 10px 0;
    max-height: 500px;
    overflow: auto;
    .no-pic{
      text-align: center;
      font-size: 12px;
      color: #878787;
      .orange{
        color: #fa9101;
        margin: 0 5px;
        font-weight: bold;
      }
      img{
        margin: 10px 0;
      }
    }
    ul{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin: 0 10px;
    }
    li{
      list-style: none;
      max-width: 172px;
      max-height: 128px;
      position: relative;
      margin-bottom: 5px;
      cursor: pointer;
      img{
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(201, 149, 149, 0.4)
      }
      .opreate-btn{
        position: absolute;
        width: 92%;
        margin: 0 4%;
        display: flex;
        justify-content: space-between;
        .btn-txt{
          color: #878787;
          align-items: center;
        }
        .delete-btn:hover{
          color: #fff;
          background: #fa9101;
          padding: 5px;
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/rightAsilde/my-gallery.vue